
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M20.167 7.81V3.648c0-1.292-.587-1.815-2.044-1.815h-3.7c-1.461 0-2.048.523-2.048 1.815v4.153c0 1.3.587 1.815 2.044 1.815h3.7c1.461.009 2.048-.514 2.048-1.806z"}}),_c('path',{attrs:{"d":"M20.167 18.123v-3.7c0-1.461-.587-2.048-2.044-2.048h-3.7c-1.461 0-2.048.587-2.048 2.044v3.7c0 1.461.587 2.048 2.044 2.048h3.7c1.461 0 2.048-.587 2.048-2.044zM9.625 7.81V3.648c0-1.292-.587-1.815-2.044-1.815h-3.7c-1.461 0-2.048.523-2.048 1.815v4.153c0 1.3.587 1.815 2.044 1.815h3.7c1.461.009 2.048-.514 2.048-1.806z","opacity":".4"}}),_c('path',{attrs:{"d":"M9.625 18.123v-3.7c0-1.461-.587-2.048-2.044-2.048h-3.7c-1.461 0-2.048.587-2.048 2.044v3.7c0 1.461.587 2.048 2.044 2.048h3.7c1.461 0 2.048-.587 2.048-2.044z"}})])])
          )
        }
      }
    